export const LIST_LIMIT_OPTIONS = [10, 15, 50];
export const DEFAULT_LIST_LIMIT = 10;
export const LIST_SEARCH_DEBOUNCE_MS = 400;

/** URL query param names */
export const LIST_FILTER_PARAMS = {
    LIMIT: "limit",
    FROM: "from",
    TO: "to",
    SEARCH: "search",
};

/** API query param names */
export const LIST_FILTER_API_PARAMS = {
    START_DATE: "start_date",
    END_DATE: "end_date",
};

export function parseListLimit(value) {
    const parsed = Number(value);
    return LIST_LIMIT_OPTIONS.includes(parsed) ? parsed : DEFAULT_LIST_LIMIT;
}

export function readDateFiltersFromParams(searchParams) {
    return {
        startDate:
            searchParams.get(LIST_FILTER_PARAMS.FROM) ||
            searchParams.get(LIST_FILTER_API_PARAMS.START_DATE) ||
            "",
        endDate:
            searchParams.get(LIST_FILTER_PARAMS.TO) ||
            searchParams.get(LIST_FILTER_API_PARAMS.END_DATE) ||
            "",
    };
}

export function clearLegacyDateParams(next) {
    next.delete(LIST_FILTER_API_PARAMS.START_DATE);
    next.delete(LIST_FILTER_API_PARAMS.END_DATE);
}
